import React from "react";
import { useTranslation } from "react-i18next";
import "./NotFound.scss";
import InvoiceSharedFooter from "../../Components/invoiceShared/InvoiceSharedFooter";
import vendorsConfig from "../../vendorsConfig";

function NotFound({ storeName, errorMessage }) {
  const { t } = useTranslation();
  const brandName = vendorsConfig?.APP_NAME || vendorsConfig?.NAME || "App";
  const brandLogo = vendorsConfig?.APP_LOGO || vendorsConfig?.LOGO;
  const title = errorMessage
    ? t("invoice.ripos-not-found-title", { defaultValue: "We are sorry" })
    : t("invoice.ripos-not-found-default-title", { defaultValue: "Page not found" });
  const message =
    errorMessage ||
    t("invoice.ripos-not-found-message", {
      defaultValue: "This invoice link is missing or no longer available.",
    });
  const hint = storeName
    ? t("invoice.ripos-not-found-store-hint", {
        defaultValue: "Unable to load this invoice for {{store}}.",
        store: storeName,
      })
    : t("invoice.ripos-not-found-hint", {
        defaultValue: "Double-check the link, then refresh to try again.",
      });

  return (
    <div className="nf-page">
      <div className="nf-atmosphere" aria-hidden="true" />

      <div className="nf-content">
      

        <div className="nf-stage">
          <span className="nf-giant" aria-hidden="true">
            404
          </span>

          <div className="nf-stub" aria-hidden="true">
            <div className="nf-stub-perforation" />
            <div className="nf-stub-lines">
              <span />
              <span />
              <span className="short" />
            </div>
            <div className="nf-stub-x">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M7 7l10 10M17 7L7 17" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
              </svg>
            </div>
          </div>
        </div>

        <h1 className="nf-title">{title}</h1>
        <p className="nf-message">{message}</p>
        <p className="nf-hint">{hint}</p>

        <button className="nf-cta" type="button" onClick={() => window.location.reload()}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M20 12a8 8 0 1 1-2.3-5.7"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path d="M20 5v5h-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          {t("invoice.ripos-try-again", { defaultValue: "Refresh page" })}
        </button>
      </div>

      <div className="nf-footer">
        <InvoiceSharedFooter text={t("invoice.ripos-secure-payment", { defaultValue: "Secure payment via " })} />
      </div>
    </div>
  );
}

export default NotFound;
